import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import DateFNS from 'date-fns';
// local
// views
import DropdownCylinderQtd from 'app/ui/commons/DropdownCylinderQtd';
// actions
import { editRow, saveRow, updateRow } from 'app/redux/actions/editConfirm/data';
// libs
import { fromUTC } from 'app/lib/helper';

class TabTableRow extends Component {
    onClickEdit = () => this.props.dispatch(editRow(this.props.stateKey, this.props.row.id, true));
    onClickSave = () => this.props.dispatch(saveRow(this.props.stateKey, this.props.row.id, this.props.row.counter));
    onInputChange = value => this.props.dispatch(updateRow(this.props.stateKey, this.props.row.id, value));

    renderEdit(isEdit) {
        return isEdit === true ? (
            <Button onClick={this.onClickSave} circular icon="check" size="mini" className="btn-save" />
        ) : (
            <Button onClick={this.onClickEdit} circular icon="pencil" size="mini" className="btn-edit" />
        );
    }

    render() {
        const { canEdit, row } = this.props;
        const { isSaved, isEdit, replacementConfirmed, patient, supplier, cylinderQtdRequested, cylinderQtdConfirmedEdit } = row;
        let cssClass = '';
        if (isEdit === true) {
            cssClass = 'row-edit';
        } else if (isSaved === true) {
            cssClass = 'row-saved';
        }

        const date = fromUTC(new Date(replacementConfirmed));
        return (
            <Table.Row className={cssClass}>
                <Table.Cell>{DateFNS.format(date, 'DD/MM/YYYY')}</Table.Cell>
                <Table.Cell className="bold uppercase wrap">{patient.name}</Table.Cell>
                <Table.Cell textAlign="center" className="wrap">
                    {supplier.name}
                </Table.Cell>
                <Table.Cell textAlign="center">{cylinderQtdRequested}</Table.Cell>
                <Table.Cell textAlign="center">
                    {isEdit === true ? (
                        <DropdownCylinderQtd maxValue={cylinderQtdRequested} minValue={0} value={cylinderQtdConfirmedEdit} onChange={this.onInputChange} />
                    ) : (
                        cylinderQtdConfirmedEdit
                    )}
                </Table.Cell>
                <Table.Cell>{canEdit ? this.renderEdit(isEdit) : null}</Table.Cell>
            </Table.Row>
        );
    }
}

TabTableRow.defaultProps = {
    canEdit: true,
};

TabTableRow.propTypes = {
    dispatch: PropTypes.func,
    row: PropTypes.object,
    stateKey: PropTypes.string,
    canEdit: PropTypes.bool,
};

export default connect()(TabTableRow);
